module.exports = __webpack_public_path__ + "img/event.d49f5ec9.jpeg";